import React, { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './AutomaticContainer.scss';

import { moduleActions } from '../../redux/modules';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../redux/utils/analytics-helper';
import {
  getIsCorporateAccountType,
  getAutoExchangeFunds,
  getRecurringPurchaseFunds,
  getRecurringRedemptionFunds,
  getAutoRMDFunds,
  getOWNRAutoMaxFunds,
  doesUserOwnAtleast1IRA,
} from '../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  didPersonalInformationFail,
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
} from '../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getHasCollegeOnly } from '../../redux/modules/productTypes/productType.selectors';
import { getTraditionalOrRolloverIraFunds } from '../../redux/modules/funds/UserFunds/userFunds.selectors';
import {
  getExistingRMD,
  getCurrentFunds,
  getIsRMDEligible,
} from '../../redux/modules/RMD/RMDSetting.selectors';
import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';
import { getApplicationStatus } from '../../redux/modules/applicationData/applicationData.selectors';

require('animate.css/animate.min.css');

export class AutomaticContainer extends Component {
  componentDidMount() {
    const {
      actions: { loadApplication, setAppLoading, getTRPFunds },
    } = this.props;
    setAppLoading();
    getTRPFunds();
    analyticsDataLayer();
    loadApplication(this.props.actions);
  }

  render() {
    const { children, ...passthroughProps } = this.props;
    return (
      <div className="automatic-container">
        {/* Nested View */}
        <div className="automatic-container-page-background" />
        {React.Children.map(children, (child) =>
          cloneElement(child, {
            ...passthroughProps,
            analyticsDataLayer,
            dispatchPageLoad,
          })
        )}
        <div className="automatic-container-clear" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    authentication,
    automaticInvestments,
    user,
    userProductTypes,
    personalInformation,
    RMDSetting,
    allFunds,
    userRegistrationTypeInfo,
    vanity: { vanityName },
  } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    applicationData: getApplicationStatus(state),
    authentication,
    automaticInvestments,
    hasAutoMaxIRAs: getOWNRAutoMaxFunds(state),
    ownsIRAs: doesUserOwnAtleast1IRA(state),
    dateOfBirth: getDateOfBirth(state),
    personalInfoFailed: didPersonalInformationFail(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
    isAddressAvailable: getIsAddressAvailable(state),
    isNotForeignAddress: getIsNotForeignAddress(state),
    isCorporateAccountType: getIsCorporateAccountType(state),
    personalInformation,
    RMDSetting,
    autoExchanges: getAutoExchangeFunds(state),
    recurringPurchases: getRecurringPurchaseFunds(state),
    recurringRedemptions: getRecurringRedemptionFunds(state),
    user,
    userProductTypes,
    userRegistrationTypeInfo,
    vanityName,
    allFunds,
    isTraditionalOrRolloverIraFunds: getTraditionalOrRolloverIraFunds(state),
    isRMDEligible: getIsRMDEligible(state),
    existingRMD: getExistingRMD(state),
    systematicActivityRMDs: getAutoRMDFunds(state),
    fundsByAgreementId: state.userFunds.fundsByAgreementID,
    currentFunds: getCurrentFunds(state),
    isMobileParam: getIsMobileParam(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AutomaticContainer
);
